import styled from 'styled-components';
import { Modal } from 'antd';

export const ModalStyled = styled(Modal)`
	.ant-modal-content {
		padding: 30px 0;
		border-radius: 30px;
		min-width: 400px;
		max-width: 520px;
	}
`;
